import {
  CLEAR_STORE,
  IS_USER_AUTHENTICATED,
  IS_USER_AUTHENTICATING,
  LOAD_USER_SESSION,
  MOBILE_VERIFICATION_SUBMIT,
  SET_IS_EU_REGION_MOBILE_VERIFIED,
  SET_IS_NEW_USER,
  SIGN_UP_NEW_USER_SUCCESS,
  SET_CSRF_TOKEN,
  SET_NEW_SIGNUP_USER,
  SET_INSTAPOINTS_BALANCE,
  UPDATE_USER_TIER
} from '../../action-contants';

const INITIAL_STATE = {
  sign_up_res: null,
  sign_up_err: null,
  log_in_res: null,
  otp_res: null,
  otp_err: null,
  user_state_res: null,
  user_state_err: null,
  is_user_authenticating: false,
  is_user_authenticated: false,
  csrf_token: null,
  isNewSignup: false,
  user_session: {
    is_new_user: null,
    isLoginOTPRequired: null,
    isLoginOTPVerified: null,
    isUserRecentlySignedUp: false,
    isReferralCodeSubmittedOnSignup: false,
    isReferralCodeSubmittedOnPersonalDetails: false
  },
  instapoint_balance: {
    initial_referral_instapoint: 0,
    min_source_amount_limit: 0,
    transaction_referral_instapoint: 0,
    total_instapoints: 0,
    instapoints: 0,
    redemption_value: 0
  }
};

export default function userSessionReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }

    case SIGN_UP_NEW_USER_SUCCESS: {
      // update the state of this reducer in the whole Redux's state on successful response using action types as a reference
      return { ...state, sign_up_res: action.data };
    }

    case MOBILE_VERIFICATION_SUBMIT: {
      let user_session = Object.assign({}, state.user_session, {
        is_phone_verified: action.data.is_phone_verified
      });
      return { ...state, user_session: user_session };
    }

    case IS_USER_AUTHENTICATING: {
      return { ...state, is_user_authenticating: action.data };
    }

    case IS_USER_AUTHENTICATED: {
      return { ...state, is_user_authenticated: action.data };
    }

    case LOAD_USER_SESSION: {
      let user_session = Object.assign({}, state.user_session, action.data);
      return { ...state, user_session: user_session };
    }

    case SET_IS_EU_REGION_MOBILE_VERIFIED: {
      let user_session = { ...state.user_session, ...action.data };
      return { ...state, user_session: user_session };
    }

    case SET_IS_NEW_USER: {
      let user_session = { ...state.user_session };
      user_session.is_new_user = action.data;
      return { ...state, user_session: user_session };
    }

    case SET_CSRF_TOKEN: {
      return { ...state, csrf_token: action.data };
    }

    case SET_NEW_SIGNUP_USER: {
      return { ...state, isNewSignup: true };
    }
    case SET_INSTAPOINTS_BALANCE: {
      return { ...state, instapoint_balance: action.data };
    }
    case UPDATE_USER_TIER: {
      const user_session = {
        ...state.user_session,
        tier: action?.data?.tier
      };
      return { ...state, user_session };
    }
    default:
      return state;
  }
}
